"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const common_utils_1 = require("@as-react/common-utils");
const common_utils_2 = require("@as-react/common-utils");
class CategoryAPI {
    constructor() {
        this.getById = (servicesApi, defaultRequestParams, categoryId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { mainWebshop, language } = defaultRequestParams;
            const endpoint = common_utils_2.Environment.isDevelopment() ? 'http://localhost:4502/' : `${servicesApi}api/`;
            const axiosConfig = {
                method: 'GET',
                url: `${endpoint}services/public/category/${mainWebshop}/${categoryId}/${language}`,
                withCredentials: true,
            };
            const result = yield common_utils_1.axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
exports.default = new CategoryAPI();
